import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader';

function Signatures() {
	return (
		<>
			<p className="justify">
				<Trans i18nKey="loan_agreement_guarantor_borrower.signatures">
					<strong>Signatures</strong>
				</Trans>
			</p>
			<p className="justify">
				<Trans i18nKey="loan_agreement_guarantor_borrower.signatures_witness">
					<strong>IN WITNESS WHEREOF, </strong>the PARTIES have executed this Contract of Guaranty at
					Place:____________________ as of the day and year first above written.
				</Trans>
			</p>
		</>
	);
}

export default hot(module)(withTranslation()(Signatures));
